import { AlternativePrice, Price } from 'src/types';

export const replaceMainOfferWithAlternativeOffer = (
  offer: Price,
  alternativeOffer: AlternativePrice
) => {
  if (!alternativeOffer) return offer;

  const newAlternatives = [
    alternativeOffer,
    ...offer.alternativePrices!.filter(alt => alt !== alternativeOffer),
  ];

  return {
    ...alternativeOffer,
    authorizedDealer: offer.authorizedDealer,
    history: offer.history,
    store: offer.store,
    alternativePrices: newAlternatives,
  } as Price;
};
